import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

// Donation Service - Record donation after payment
export const makeDonation = async (donationData) => {
  try {
    const response = await axiosInstance.post(API_ENDPOINTS.MAKE_DONATION, donationData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  makeDonation
};

